module.exports = __webpack_public_path__ + "static/img/login_background.5246472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_background.png
// module id = rjqs
// module chunks = 3